import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "relative" }

import { ref, computed } from 'vue';
import {
  Combobox,
  ComboboxButton,
  ComboboxInput,
  ComboboxLabel,
  ComboboxOption,
  ComboboxOptions,
} from '@headlessui/vue';
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/vue/20/solid';


export default /*#__PURE__*/_defineComponent({
  __name: 'RecordTypePicker',
  props: {
  modelValue: {
    type: String,
    default: '',
  },
},
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const props = __props;





const value = computed({
  get() {
    return props.modelValue;
  },
  set(newValue) {
    emit('update:modelValue', newValue);
  },
});

const recordTypes = ['A', 'AAAA', 'AFSDB', 'APL', 'CAA', 'CDNSKEY', 'CDS', 'CERT', 'CNAME', 'CSYNC', 'DHCID', 'DLV', 'DNAME', 'DNSKEY', 'DS', 'HINFO', 'HIP', 'IPSECKEY', 'IXFR', 'KEY', 'KX', 'LOC', 'MX', 'NAPTR', 'NS', 'NSEC', 'NSEC3', 'NSEC3PARAM', 'OPENPGPKEY', 'OPT', 'PTR', 'RP', 'RRSIG', 'SIG', 'SMIMEA', 'SOA', 'SRV', 'SSHFP', 'TA', 'TKEY', 'TLSA', 'TSIG', 'TXT', 'URI', 'ZONEMD'];
const recordTypeQuery = ref(props.modelValue);
const filteredRecordTypes = computed(() => (recordTypeQuery.value === ''
  ? recordTypes
  : recordTypes.filter((item) => item.toLowerCase().includes(recordTypeQuery.value.toLowerCase()))));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Combobox), {
    as: "div",
    class: "inline-block",
    modelValue: _unref(value),
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(value) ? (value).value = $event : null))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(ComboboxLabel), { class: "block text-sm font-medium text-gray-600" }, {
        default: _withCtx(() => [
          _createTextVNode("Record type")
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(ComboboxInput), {
          onChange: _cache[0] || (_cache[0] = ($event: any) => (recordTypeQuery.value = $event.target.value)),
          onFocus: _cache[1] || (_cache[1] = ($event: any) => (recordTypeQuery.value = '')),
          class: "w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 sm:text-sm"
        }),
        _createVNode(_unref(ComboboxButton), { class: "absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none" }, {
          default: _withCtx(() => [
            _createVNode(_unref(ChevronUpDownIcon), {
              class: "h-5 w-5 text-gray-400",
              "aria-hidden": "true"
            })
          ]),
          _: 1
        }),
        (_unref(filteredRecordTypes).length > 0)
          ? (_openBlock(), _createBlock(_unref(ComboboxOptions), {
              key: 0,
              class: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredRecordTypes), (person) => {
                  return (_openBlock(), _createBlock(_unref(ComboboxOption), {
                    key: person,
                    value: person,
                    as: "template"
                  }, {
                    default: _withCtx(({ active, selected }) => [
                      _createElementVNode("li", {
                        class: _normalizeClass(['relative cursor-default select-none py-2 pl-3 pr-9', active ? 'bg-indigo-600 text-white' : 'text-gray-900'])
                      }, [
                        _createElementVNode("span", {
                          class: _normalizeClass(['block truncate', selected && 'font-semibold'])
                        }, _toDisplayString(person), 3),
                        selected
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: _normalizeClass(['absolute inset-y-0 right-0 flex items-center pr-4', active ? 'text-white' : 'text-indigo-600'])
                            }, [
                              _createVNode(_unref(CheckIcon), {
                                class: "h-5 w-5",
                                "aria-hidden": "true"
                              })
                            ], 2))
                          : _createCommentVNode("", true)
                      ], 2)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})